<template>
  <div>
    <el-descriptions :title="title" border>
      <el-descriptions-item :label="item.name" v-for="(item, index) in config" :key="index">
        <div v-if="item.input">
          <div v-if="item.type && item.type == 'select'">
            <el-select v-model="localData[item.key]" filterable placeholder="请选择">
              <el-option v-for="s in options" :key="s.id" :label="s.label" :value="s.id"> </el-option>
            </el-select>
          </div>

          <el-input v-model="localData[item.key]" v-else />
        </div>

        <div v-else-if="!item.type">
          {{ localData[item.key] }}
        </div>
        <div v-else>
          {{ localData[item.key] }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    config: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      localData: {}
    }
  },

  created() {
    this.localData = this.value
  },
  watch: {
    localData: {
      handler(newVal) {
        if (!this.isEqual(newVal, this.value)) {
          this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
        }
      },
      deep: true
    }
  },
  methods: {
    isEqual(a, b) {
      // 智能值比对（处理所有数据类型）
      if (typeof a !== typeof b) return false
      if (typeof a === 'object' && a !== null && b !== null) {
        // 处理引用类型
        return _.isEqual(a, b) // 使用 lodash 深度比对
      }
      return a === b // 基本类型直接比对
    }
  }
}
</script>

<style lang="scss" scoped></style>
